import * as React from 'react';
import { 
  Box,
  CircularProgress,
  DialogContent,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField, CSelect } from '../components/common/Modal';
import { setLoading, setVisualization } from '../slices/visualization';

export default function PromptModal(props) {
  const {open, value, id, title, type, color, handleClose} = props;
  const defaultDb = useSelector(state => state.auth.currentDB);
  const dbs = useSelector(state => state.auth.user.db)
  const [prompt, setPrompt] = React.useState(value);
  const [database, setDatabase] = React.useState(defaultDb);

  const dispatch = useDispatch();  
  const loading = useSelector(state => state.visualization.loading)

  const handlePrompt = (e) => {
    setPrompt(e.target.value)
  }

  const handleSave = (e) => {
    dispatch(setLoading());  
    dispatch(setVisualization({ db: database, prompt, title, type, color, id }))
    .then(() => {
      handleClose(); // Call handleClose after the setVisualization action has finished
    });
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        fullWidth
      >
        <CDialogTitle>Edit Prompt</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <FormControl sx={{mt: 1}} fullWidth>
          <InputLabel id="graph-data-source-label">Data Source</InputLabel>
          <CSelect
            labelId="graph-data-source-label"
            id="demo-simple-select"
            value={database}
            margin='dense'
            label="Data Source"
            onChange={(e) => setDatabase(e.target.value)}
            fullWidth={true}
            variant='outlined'
            >
              {
                dbs && dbs.length>0 && dbs.map(item=> (<MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>))
              }
          </CSelect>
        </FormControl>
        <CTextField
            id={`prompt`} 
            label={`Prompt`}
            size="small"
            multiline
            rows={3}
            variant="outlined"
            value={prompt}
            onChange={handlePrompt}
            sx={{
              marginTop: '1rem'
            }}
            fullWidth
          />
          
          {loading && (
            <Box className="absolute w-full h-full" sx={{top: 0, left: 0}}>
              <Box className="relative w-full h-full">
                <Box className="w-full h-full flex justify-center align-center">
                  <CircularProgress sx={{opacity: 0.7}} />
                </Box>
              </Box>
            </Box>)
          }  
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleSave}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}